//gives pdf in blob format

export const downloadPDF = ({ file, showAlert, fileName }) => {
  let doc = "";
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    doc = reader.result;
    fetch(doc).then(function (t) {
      return t.blob().then((b) => {
        var a = document.createElement("a");
        a.href = URL.createObjectURL(b);
        a.setAttribute("download", fileName);
        a.click();
      });
    });
  };
  reader.onerror = function (error) {
    showAlert("error", "This File is not Readable");
  };
};
